import appearImg from "../images/appear.png"
import sporkImg from "../images/spork.png"
import tarouImg from "../images/tarou.png"
import skipImg from "../images/skip.png"

let projectData = [
  {
    id: 0,
    project: "Appear",
    img: appearImg,
    deployed: "http://appear.surge.sh",
    github: "https://github.com/kellymakesstuff/appear-rsvp"
  },
  {
    id: 1,
    project: "SPORK",
    img: sporkImg,
    deployed: "http://spork-app.surge.sh",
    github: "https://github.com/kellymakesstuff/spork"
  },
  {
    id: 2,
    project: "Tarou",
    img: tarouImg,
    deployed: "http://tarou.netlify.app",
    github: "https://github.com/kellymakesstuff/tarou-tarot-card-reader"
  },
  {
    id: 3,
    project: "The SKIP Chinese Character Dictionary",
    img: skipImg,
    deployed: "http://skip-chinese.surge.sh",
    github: "https://github.com/kellymakesstuff/skip-chinese-dictionary"
  },

]
export default projectData